export default "__VITE_ASSET__DrFXiEya__"